import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { waLink } from "@/lib/site";
import { trackEvent } from "@/lib/tracking";

export default function CtaBand({ title, text }) {
    return (
        <section
            data-testid="cta-band"
            className="grain relative overflow-hidden bg-[#08104F] px-5 py-20 text-center sm:px-8 sm:py-28"
        >
            <div
                className="pointer-events-none absolute left-1/2 top-0 h-[420px] w-[720px] -translate-x-1/2 rounded-full opacity-60"
                style={{ background: "radial-gradient(ellipse at center, rgba(0,71,187,0.35), transparent 65%)" }}
            />
            <div className="relative mx-auto max-w-3xl">
                <h2 className="font-display text-3xl leading-[1.15] tracking-tight text-[#F3EDE6] sm:text-4xl lg:text-5xl">
                    {title}
                </h2>
                <p className="mx-auto mt-5 max-w-xl text-base leading-relaxed text-[#B2D0FF] sm:text-lg">
                    {text}
                </p>
                <div className="mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row">
                    <Link
                        to="/contato"
                        data-testid="btn-ctaband-diagnostic"
                        className="group inline-flex items-center gap-2 rounded-full bg-white px-7 py-3.5 text-sm font-semibold text-[#08104F] transition-all duration-200 hover:bg-[#B2D0FF] active:scale-[0.97]"
                    >
                        Solicitar diagnóstico gratuito
                        <ArrowUpRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                    </Link>
                    <motion.a
                        href={waLink()}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="btn-ctaband-whatsapp"
                        onClick={() => trackEvent("whatsapp_click", { location: "cta_band" })}
                        whileTap={{ scale: 0.97 }}
                        className="inline-flex items-center gap-2 rounded-full border border-white/25 px-7 py-3.5 text-sm font-semibold text-[#F3EDE6] transition-colors duration-200 hover:border-white/60 hover:bg-white/5"
                    >
                        Chamar no WhatsApp
                    </motion.a>
                </div>
            </div>
        </section>
    );
}
